// Source of truth for the mobile breakpoint. Keep in sync with the duplicated
// media queries in BootstrapInput.module.css and bootstrap.ts (shadow DOM CSS).
export const MOBILE_QUERY =
  'only screen and (max-width: 500px), screen and (orientation: landscape) and (max-height: 500px)';

export function isMobileWidth(): boolean {
  return window.matchMedia(MOBILE_QUERY).matches;
}
